import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer = () => (
  <Box
    component="footer"
    sx={{
      bgcolor: 'black',
      color: 'white',
      textAlign: 'center',
      py: 3,
      px: 2,
      mt: 'auto',
    }}
  >
    <Typography variant="h6" gutterBottom>
      LA Catering
    </Typography>
    <Typography variant="body2">
      670 Harmon Ave, Columbus, Ohio 43223
    </Typography>
    <Typography variant="body2">
      Telephone: <Link href="tel:6143585252" color="inherit" underline="hover">614-358-LALA (5252)</Link>
    </Typography>
    <Typography variant="body2">
      <Link href="https://www.la-catering.com/" target="_blank" rel="noopener" color="inherit" underline="hover">
        www.la-catering.com
      </Link>
    </Typography>
  </Box>
);

export default Footer;
